export enum Names {
  "RECENT" = "RECENT",
  "SHARES" = "SHARES",
  "MY_SHARE" = "MY_SHARE",
  "MY_SPACE" = "MY_SPACE",
  "TEAM_SPACE" = "TEAM_SPACE",
  "ZHUANBAN" = "ZHUANBAN",
  "GROUP" = "GROUP"
}

export enum PageMenuTypesLogId {
  clone = "26", // 创建副本
  collect = "8", // 收藏
  uncollect = "9", // 取消收藏
  copy = "13", // 复制到
  copyCancel = "14", // 复制到点击取消
  copyClose = "15", // 复制到点击关闭
  download = "18", // 下载
  edit = "31", // 打开
  move = "28", // 移动到
  moveCancel = "29", // 移动到点击取消
  moveClose = "30", // 移动到点击关闭
  doMove = "files-move", // 执行移动操作
  delete = "25", // 删除
  remove = "17", // 最近列表删除
  rename = "24", // 重命名
  shared = "16", // 分享
  shortcut = "10", // 置顶
  unshortcut = "11", // 取消置顶
  sync = "32", // 同步
  collaborate = "42", // 管理协作者
  other = -1
}

export const getPageMenuLogId = (type: string, data?: any): string => {
  if (type === PageMenuTypesLogId.collect && data?.isCollected) {
    return PageMenuTypesLogId.uncollect;
  }
  if (type === PageMenuTypesLogId.shortcut && data?.isShortcuted) {
    return PageMenuTypesLogId.unshortcut;
  }
  // @ts-ignore
  return PageMenuTypesLogId[type || "other"];
};

export const getLoactionFrom = () => {
  const path = window.location.href;
  let rFrom = "";
  if (path.includes("recent")) {
    rFrom = "RECENT";
  }
  if (path.includes("shares")) {
    rFrom = "SHARES";
  }
  if (path.includes("myshare")) {
    rFrom = "MY_SHARE";
  }
  if (path.includes("collections")) {
    rFrom = "collections";
  }
  if (path.includes("teamspace")) {
    rFrom = "TEAM_SPACE";
  }
  if (path.includes("myspace")) {
    rFrom = "MY_SPACE";
  }
  if (path.includes("messages")) {
    rFrom = "GROUP";
  }
  return rFrom;
};
